import reducer from "./reducer";
export { default as BotAssistant } from "./components/index";
export { default as botAssistantReducerName } from "./constants";
export default reducer;